/**
 * KED-1699 Create Input Dropdown
 * https://kpmg-au-ddx.atlassian.net/browse/KED-1699
 *
 * This component uses Semantic-UI dropdown:
 * https://semantic-ui.com/modules/dropdown.html
 */
import {Component, Input, OnInit, ViewChild, ElementRef, ChangeDetectorRef, AfterViewInit, NgZone} from "@angular/core";
import {IAnswer, IFormField, ListOption} from "../form-field-wrapper/form-field-wrapper.component";
import {UntypedFormControl, FormGroup, Validators} from "@angular/forms";

declare var $: any;

@Component({
    selector: 'app-dropdown-field',
    templateUrl: './dropdown-field.component.html',
    styleUrls: ['./dropdown-field.component.scss'],
    standalone: false
})
export class DropdownFieldComponent implements OnInit, AfterViewInit {
  @Input() myFormControl: UntypedFormControl;
  @Input() question: IFormField;
  @Input() disabled?: boolean;
  @Input() tabIndex?: number = 0;
  @ViewChild('dropDown') dropDown: ElementRef; // the semantic-ui dropdown

  constructor(private zone: NgZone) {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {

    // get the placeholder
    const valuesPlaceholder: {}[] = [{
      name: this.question.placeholder || "Pick an answer",
      value: "",
      order: 0
    }];

    const valuesOptions: {}[] = this.question.questionDropdowns
      .map((item: ListOption) => ({
        name: item.display, // the menu label
        value: item.value,
        selected: this.myFormControl.value && this.myFormControl.value === item.value, // default selection
        order: item.order,
        disabled: item.disabled
      })).sort((a, b) => a.order - b.order);

      // init semantic-ui dropdown
    $(this.dropDown.nativeElement).dropdown({
      values: valuesPlaceholder.concat(valuesOptions),
      placeholder: this.question.placeholder || "Pick an answer",
      fullTextSearch: "exact",
      preserveHTML: false,
      direction: this.question.dropdownDirection || 'auto',
      allowTab: false, // allows us to manually control tab index
      // append same value from questionDropdown list
      // default value for empty option is "", it cannot be null
      // the empty value from api returns null so need to compare against selected empty option
      onChange: (value: string, text: string) => this.zone.run(() => {
        const answer = this.question.answers.length && this.question.answers[0];
        const originalAnswer = answer && answer.answer != null ? answer.answer : '';

        if (text) {
          this.myFormControl.setValue(value);
        }

        // when original answer is null, and selecting an empty value
        if (text === 'Pick an answer' && !originalAnswer) {
          this.myFormControl.markAsPristine();

          // when selecting a non-empty option that differs to the original
        } else if (text && value !== originalAnswer) {
          this.myFormControl.markAsDirty();

          // when selecting the original value
        } else if (value === originalAnswer) {
          this.myFormControl.markAsPristine();
        }
      }),
    });
  }
}

const dropdownFieldValidators = (question: IFormField) => {
  const validators = [];
  if (question.mandatory) validators.push(Validators.required);
  return validators;
};

export const makeDropdownFieldFormControl = (q: IFormField, answer?: IAnswer) => {
  const answerValue = answer ? answer.answer : (q.default != null ? String(q.default) : "");
  q.validators = dropdownFieldValidators(q);
  const formControl = new UntypedFormControl(answerValue, {validators: Validators.compose(q.validators)});
  if (!answer && answerValue) {
    formControl.markAsDirty();
  }
  return formControl;
};
